import { useIntl } from '@/intl'

import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    emailsLabel: translate({
      id: 'settings.messagingPlan.view.emailsLabel',
    }),
    resetEmailCounter: translate({ id: 'settings.messagingPlan.view.resetEmailCounter' }),
    sentEmails: (count: string) =>
      translate({ id: 'settings.messagingPlan.view.sentEmails', values: { count } }),

    sentEmailsSince: (date: string, days: number) =>
      translate({
        id: 'settings.messagingPlan.view.sentEmailsSince',
        values: { date, days },
      }),
  }))

  return api
}
